import { instance } from '@/services/avik-api-gateway'
import { AxiosResponse } from 'axios'
import { DeviationDisruption } from '@/types/deviation-disruption'

export function createDeviationDisruption(
  body: Partial<DeviationDisruption>
): Promise<AxiosResponse<DeviationDisruption>> {
  return instance.post(`/deviation-disruption`, body)
}
